<template>
    <div class="t-lk-online-courses t-container">
        <div class="t-title__row">
            <h1 class="t-lk-online-courses__title">{{ $root.staticText.lk.materialsOnlineCoursesTitle }}</h1>

            <div class="t-events-buttons">
                <router-link
                    class="t-btn-green t-lk-materials__btn router-link-active"
                    :class="{_active: $route.query.favorite}"
                    :to="{
                    name: $route.name,
                    query: {
                        ...$route.query,
                        favorite: $route.query.favorite ? undefined : true,
                        currentPage: undefined
                    }
                }"
                >
                    {{ $root.staticText.lk.materialsOnlineCoursesFavorite }}
                </router-link>
                <div class="t-events-buttons__item" @click="activeView = true" :class="{_active: activeView}">
                    <svg class="t-events-buttons__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.29412 7.55556C8.29412 7.24873 8.57903 7 8.93048 7H18.3636C18.7151 7 19 7.24873 19 7.55556V7.87302C19 8.17984 18.7151 8.42857 18.3636 8.42857H8.93048C8.57903 8.42857 8.29412 8.17984 8.29412 7.87302V7.55556Z" fill="#929292"/>
                        <path d="M5 7.55556C5 7.24873 5.28491 7 5.63636 7H6.01069C6.36215 7 6.64706 7.24873 6.64706 7.55556V7.87302C6.64706 8.17984 6.36215 8.42857 6.0107 8.42857H5.63636C5.28491 8.42857 5 8.17984 5 7.87302V7.55556Z" fill="#929292"/>
                        <path d="M8.29412 11.8413C8.29412 11.5344 8.57903 11.2857 8.93048 11.2857H18.3636C18.7151 11.2857 19 11.5344 19 11.8413V12.1587C19 12.4656 18.7151 12.7143 18.3636 12.7143H8.93048C8.57903 12.7143 8.29412 12.4656 8.29412 12.1587V11.8413Z" fill="#929292"/>
                        <path d="M5 11.8413C5 11.5344 5.28491 11.2857 5.63636 11.2857H6.01069C6.36215 11.2857 6.64706 11.5344 6.64706 11.8413V12.1587C6.64706 12.4656 6.36215 12.7143 6.0107 12.7143H5.63636C5.28491 12.7143 5 12.4656 5 12.1587V11.8413Z" fill="#929292"/>
                        <path d="M8.29412 16.127C8.29412 15.8202 8.57903 15.5714 8.93048 15.5714H18.3636C18.7151 15.5714 19 15.8202 19 16.127V16.4444C19 16.7513 18.7151 17 18.3636 17H8.93048C8.57903 17 8.29412 16.7513 8.29412 16.4444V16.127Z" fill="#929292"/>
                        <path d="M5 16.127C5 15.8202 5.28491 15.5714 5.63636 15.5714H6.01069C6.36215 15.5714 6.64706 15.8202 6.64706 16.127V16.4444C6.64706 16.7513 6.36215 17 6.0107 17H5.63636C5.28491 17 5 16.7513 5 16.4444V16.127Z" fill="#929292"/>
                    </svg>
                    <div class="t-events-buttons__text">{{ $root.staticText.typeList.list }}</div>
                </div>
                <div class="t-events-buttons__item _stroke" @click="activeView = false" :class="{_active: !activeView}">
                    <svg class="t-events-buttons__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 5H5V10H10V5Z" stroke="#929292" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19 5H14V10H19V5Z" stroke="#929292" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19 14H14V19H19V14Z" stroke="#929292" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 14H5V19H10V14Z" stroke="#929292" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="t-events-buttons__text">{{ $root.staticText.typeList.grid }}</div>
                </div>
            </div>
        </div>
        <div class="t-lk-online-courses__container _top">
            <filter-container-cmp
                v-if="filter.length"
                :is-filter-date="false"
                :is-clear-filter="true"
                :filter="filter"
                :is-reset-filter="true"
                :name-btn="$root.staticText.sort"
            ></filter-container-cmp>
            <filter-search-cmp
                class="t-lk-filter__search"
                :is-lk="true"
                action="lk/price-lists/searchItems"
            ></filter-search-cmp>
        </div>

        <div class="t-lk-online-courses__wrap">
            <div class="t-lk-online-courses__tags-container">
                <h3 class="t-lk-online-courses__tags-title">{{ $root.staticText.lk.materialsOnlineCoursesTags }}</h3>
                <tags-cmp
                    :tags="tags"
                    class="t-lk-online-courses__tags"
                    :white="true"
                    :is-container="false"
                    ></tags-cmp>
            </div>
            <div class="t-lk-online-courses__content">
                <sort-cmp
                    :list="sort"
                ></sort-cmp>
                <transition name="fadeChange">
                <div :class="['t-lk-online-courses__grid-container', { _list: activeView }]">
                    <card-course-cmp
                        v-for="item in courses"
                        :key="item.id"
                        :item="item"
                        :active-view="activeView"
                        @toggleFavorites="toggleFavorites"
                    ></card-course-cmp>
                    <pagination-cmp
                        v-animation:bottom.delay
                        v-if="pagination"
                        :pagination="pagination"
                        :name-current-page="'currentPage'"
                        class="_lk"
                    >
                    </pagination-cmp>
                </div>
            </transition>
            </div>

        </div>
    </div>
</template>

<script>
import filterContainer from "@ui/filter-container/filter-container";
import formGreen from "@base/form-green";
import tagsBlock from "@ui/tags/tags";
import search from "@ui/search/component";
import filterSearch from "@ui/filter-search/filter-search";
import cardCourse from "@ui/card-course/card-course";
import pagination from "@ui/pagination/pagination";
import sort from "@ui/sort/sort";
import Vue from "vue";
import onScrollAnimate from "@assets/js/scrollAnimate";

export default {
    name: "index.vue",
    components: {
        'filter-container-cmp': filterContainer,
        'pagination-cmp': pagination,
        'form-green-cmp': formGreen,
        'card-course-cmp': cardCourse,
        'tags-cmp': tagsBlock,
        'search-cmp': search,
        'filter-search-cmp': filterSearch,
        'sort-cmp': sort
    },
    data() {
        return {
            sort: [],
            filter: [],
            courses: [],
            tags: [],
            pagination: null,
            activeView: false
        }
    },
    methods: {
        setData(data) {
            this.sort = data.sort;
            this.filter = data.filter;
            this.courses = data.courses;
            this.tags = data.tags;
            this.pagination = data.pagination;
        },
        toggleFavorites(val) {
            this.courses.find(item => item.id === val.id).isFavorite = val.isFavorite
        }
    },
    beforeRouteUpdate(to, from, next) {
        let url = process.env.NODE_ENV !== 'production' ? 'lk/materialsOnlineCourses.json' : 'lk/materials-online-courses';

        Vue.http.get(url, {params: to.query}).then(
            (data) => {
                this.setData(data.data);
                next();
                setTimeout(() => {
                    onScrollAnimate();
                }, 500);
            },
            (data) => {
                if (data.status === 403) {
                    next({name: 'E403'})
                } else {
                    next({name: 'E404'})
                }
            }
        );
    },
    beforeRouteEnter(to, from, next) {
        let url = process.env.NODE_ENV !== 'production' ? 'lk/materialsOnlineCourses.json' : 'lk/materials-online-courses';
        Vue.http.get(url, {params: to.query}).then(
            (data) => {
                next(vm => vm.setData(data.data));
            },
            (data) => {
                if (data.status === 403) {
                    next({name: 'E403'})
                } else {
                    next({name: 'E404'})
                }
            }
        );
    },
}
</script>


// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-online-courses/index.vue